import React from "react";

// Import wearable logos
import appleLogo from "../../assets/wearable/apple.png";
import corosLogo from "../../assets/wearable/coros.png";
import fitbitLogo from "../../assets/wearable/fitbit.png";
import garminLogo from "../../assets/wearable/garmin.png";
import googleLogo from "../../assets/wearable/google.png";
import ouraLogo from "../../assets/wearable/oura.png";
import polarLogo from "../../assets/wearable/polar.png";
import suuntoLogo from "../../assets/wearable/suunto.png";
import ultrahumanLogo from "../../assets/wearable/ultrahuman.png";
import whoopLogo from "../../assets/wearable/whoop.png";
import zeppLogo from "../../assets/wearable/zepp.png";

interface LogosProps {
  title?: string;
  subtitle?: string;
  backgroundColor?: string;
  showTitle?: boolean;
  logoSize?: "small" | "medium" | "large";
}

const wearableLogos = [
  { src: appleLogo, alt: "Apple Watch", name: "Apple" },
  { src: garminLogo, alt: "Garmin", name: "Garmin" },
  { src: polarLogo, alt: "Polar", name: "Polar" },
  { src: whoopLogo, alt: "Whoop", name: "Whoop" },
  { src: fitbitLogo, alt: "Fitbit", name: "Fitbit" },
  { src: ouraLogo, alt: "Oura Ring", name: "Oura" },
  { src: corosLogo, alt: "Coros", name: "Coros" },
  { src: suuntoLogo, alt: "Suunto", name: "Suunto" },
  { src: googleLogo, alt: "Google Fit", name: "Google" },
  { src: ultrahumanLogo, alt: "Ultrahuman", name: "Ultrahuman" },
  { src: zeppLogo, alt: "Zepp", name: "Zepp" },
];

export default function Logos({
  title = "Compatible with your favorite wearables",
  subtitle = "",
  backgroundColor = "bg-base-100",
  showTitle = true,
  logoSize = "medium",
}: LogosProps) {
  const sizeClasses = {
    small: "h-8 md:h-10",
    medium: "h-12 md:h-16",
    large: "h-16 md:h-20",
  };

  return (
    <section className={`${backgroundColor} py-32 px-6`}>
      <div className="max-w-6xl mx-auto">
        {/* Title Section */}
        {showTitle && title && (
          <div className="text-center mb-12 max-w-xl mx-auto">
            <h2 className="text-4xl md:text-6xl font-light font-grotesk text-base-content mb-3">
              Integrate <strong className="font-bold">Wearables</strong>
            </h2>
            <p>
              Sync Activity GPS, Heart Rate Zones, Steps, Sleep, Heart Rate
              Variability, Resting Heart Rate and Respiratory Rate.
            </p>
            {subtitle && (
              <p className="text-lg text-base-content/80 font-grotesk max-w-2xl mx-auto">
                {subtitle}
              </p>
            )}
          </div>
        )}

        {/* Logos Grid */}
        <div className="grid grid-cols-3 md:flex md:flex-wrap justify-center items-center gap-8 md:gap-12">
          {wearableLogos.map((logo, index) => (
            <div
              key={index}
              className="flex items-center justify-center transition-all duration-300 opacity-70 hover:opacity-100"
            >
              <img
                src={logo.src}
                alt={logo.alt}
                className={`${sizeClasses[logoSize]} w-auto object-contain`}
                title={logo.name}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
